var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427.01 77.88C380.28 31.14 318.14 5.41 252.05 5.41S123.82 31.14 77.09 77.88C30.35 124.61 4.62 186.75 4.62 252.84S30.35 381.07 77.09 427.8c46.73 46.74 108.87 72.48 174.96 72.48s128.23-25.74 174.96-72.48c46.74-46.73 72.48-108.87 72.48-174.96s-25.74-128.23-72.48-174.96zM252.05 451.97c-109.8 0-199.12-89.33-199.12-199.13S142.25 53.72 252.05 53.72s199.13 89.32 199.13 199.12-89.33 199.13-199.13 199.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.64 209.13l87.37 76.28L373.5 160.1c8.72-9.63 7.89-24.53-1.85-33.13l-.01-.01c-9.56-8.44-24.12-7.64-32.69 1.79L256 219.99l-52.68-46c-9.7-8.47-24.44-7.47-32.91 2.23-8.47 9.71-7.47 24.44 2.23 32.91z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.04e3b016.svg";
export { ForwardRef as ReactComponent };